import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { CurrentUserStore } from "stores/users/CurrentUserStore";
import UserNotification from "util/UserNotification";
const viewsUrl = qualifyUrl("/views");
const viewsIdUrl = (id) => qualifyUrl(`/views/${id}`);
export const getView = (viewId) => fetch("GET", viewsIdUrl(viewId));
export const deleteView = (view) => fetch("DELETE", viewsIdUrl(view.id)).catch((error) => {
  UserNotification.error(`Deleting view ${view.title} failed with status: ${error}`, "Could not delete view");
});
export const createView = (view, entityShare, clonedFrom) => {
  const url = clonedFrom ? viewsIdUrl(clonedFrom) : viewsUrl;
  const promise = fetch("POST", url, JSON.stringify({ entity: view.toJSON(), share_request: entityShare }));
  return promise.then((response) => {
    CurrentUserStore.reload();
    return response;
  });
};
export const updateView = (view, entityShare) => fetch("PUT", viewsIdUrl(view.id), JSON.stringify({ entity: view.toJSON(), share_request: entityShare }));
